// ./store/notification-context.js
"use client";
import AlertNotification from "@/components/AlertNotification";
import { Alert, AlertColor } from "@mui/material";
import { createContext, useState, useEffect } from "react";

const NotificationContext = createContext({
  notification: null, //{severity, message}
  showNotification: function (notificationData: any) {},
  hideNotification: function () {},
});

export function NotificationContextProvider({ ...props }) {
  const [activeNotification, setActiveNotification]: any = useState();

  // useEffect(() => {
  //   if (activeNotification) {
  //     const timer = setTimeout(() => {
  //       setActiveNotification(null);
  //     }, 4000);

  //     return () => {
  //       clearTimeout(timer);
  //     };
  //   }
  // }, [activeNotification]);

  function showNotificationHandler(notificationData: any) {
    setActiveNotification(notificationData);
  }

  function hideNotificationHandler() {
    setActiveNotification(null);
  }

  const context = {
    notification: activeNotification,
    showNotification: showNotificationHandler,
    hideNotification: hideNotificationHandler,
  };

  return (
    <NotificationContext.Provider value={context}>
      {activeNotification && (
        <AlertNotification
          lang={props.lang}
          severity={activeNotification?.severity}
          message={activeNotification?.message}
          position={activeNotification?.position}
          {...activeNotification}
        />
      )}
      {props.children}
    </NotificationContext.Provider>
  );
}

export default NotificationContext;
